<template>
    <div class="columns">
        <div class="column">
            <a
                href="javascript:;"
                class="button button-blue"
                @click="quantity--"
            >-</a>
            <div class="is-inline-block mx-2">
                <input v-model="quantity" type="number" step="1" min="1" class="product-quantity">
            </div>
            <a
                href="javascript:;"
                class="button button-blue"
                @click="quantity++"
            >+</a>
            <p v-if="message"><small>{{ i18n.na_sklade_nie_je_dostatocny_pocet_kusov }}</small></p>
        </div>
        <div class="column">
            <a href="javascript:;" class="button button-orange is-pulled-right" v-if="!added && !loading" @click="addToCart(id)">{{ i18n.do_kosika}}</a>
            <div :class="{'button': true, 'button-green': !loading, 'button-no-action': true, 'is-pulled-right': true}"
                 v-else>
                <template v-if="!loading"><span class="material-icons">done</span> &nbsp; {{ i18n.pridane }}</template>
                <template v-else>{{ i18n.pridavam }} &nbsp; <span class="material-icons rotating">hourglass_bottom</span>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import cart from "../cart.js";

export default {
    props: {
        id: Number,
        slug: String,
        product: Object
    },
    data: function () {
        return {
            added: false,
            loading: false,
            quantity: 1,
            message: false,
            i18n: i18n
        };
    },
    watch: {
        quantity(val) {
            let q = parseInt(val);
            if (val && !Number.isInteger(q)) {
                this.quantity = 1;
            }

            if (q < 1) {
                this.quantity = 1;
            }

            if (q > this.product.count) {
                this.quantity--;
            }
        }
    },
    mounted() {
    },
    methods: {
        async addToCart(id) {
            this.loading = true;
            let added = false;
            this.message = false;
            try {
                await cart.addItem(id, this.quantity);
                added = true;
            } catch (e) {
                if(e.response.status === 400) {
                    this.message = true;
                }
                added = false;
            }

            setTimeout(() => {
                this.added = added;
                this.loading = false;
            }, 1000);
        }
    }
};
</script>

